
import React from 'react';

import { Table } from 'antd';
import { renderGender } from '@/utils/helpers';

const CustomerRelationshipsTable = ({ data }) => {
    if (!data || data.length === 0) return '—';

    const columns = [
        {
            title: 'Họ tên',
            dataIndex: ['related_customer', 'full_name'],
            key: 'full_name',
            render: (text, record) => {
                const customerId = record?.related_customer?.id;
                return (
                    <a
                        href={`/customer/${customerId || '#'}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {text || '—'}
                    </a>
                );
            },
        },
        {
            title: 'Mối quan hệ',
            dataIndex: ['type', 'name'],
            key: 'relationship',
            render: (text) => text || '—',
        },
        {
            title: 'Giới tính',
            dataIndex: ['related_customer', 'gender'],
            key: 'gender',
            render: (gender) => renderGender(gender),
        },
        {
            title: 'Mã khách hàng',
            dataIndex: ['related_customer', 'code'],
            key: 'code',
        },
        {
            title: 'Trạng thái',
            dataIndex: ['related_customer', 'is_deleted'],
            key: 'is_deleted',
            render: (is_deleted) => (is_deleted ? <span style={{ color: 'red' }}>Đã xóa</span> : <span style={{ color: 'green' }}>Hoạt động</span>),
        },
    ];


    return (
        <Table
            size="small"
            pagination={false}
            columns={columns}
            dataSource={data}
            rowKey={(r) => r.id}
        />
    );
};

export default CustomerRelationshipsTable;
